import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { from, of } from 'rxjs';
import { map, skipWhile, switchMap, catchError, tap } from 'rxjs/operators';
import { AuthService } from 'addiction-auth';
import { ROUTES_NAME } from '../models/routes-name';
import { showSugarAuthError, SugarAuthService } from './sugar-auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  authService = inject(AuthService);
  sugarAuth = inject(SugarAuthService);
  router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.authService.isDoneLoading$.pipe(
      skipWhile((x) => !x),
      switchMap(() => {
        if (this.authService.hasValidToken()) {
          return of(true);
        }
        if (this.sugarAuth.isSugarIframe) {
          // Nell'iframe non si va alla pagina di login (redirect Keycloak impossibile): si rifà
          // l'handshake con Sugar.
          return from(this.sugarAuth.ensureAuthenticated()).pipe(
            map(() => this.authService.hasValidToken()),
            catchError(() => of(false)),
            tap((ok) => {
              if (!ok) showSugarAuthError();
            })
          );
        }
        this.router.navigate([ROUTES_NAME.LOGIN]);
        return of(false);
      })
    );
  }
}
